import * as React from 'react';
import classNames from 'classnames';
import './fieldStyles.less';
import '../commonComponents.less';
import Canvas from './Canvas';
import ConsentSignature from '../../models/be/ConsentSignature';

const DigitalSignatureField = (props: Props) => {
	return (
		<div className={classNames('digitalSignatureField')}>
			<Canvas
				email={props.email}
				workflowId={props.workflowId}
				consentSignature={props.consentSignature}
				candidateId={props.candidateId}
				customerId={props.customerId}
				onUpload={props.onUpload}
				errorMessage={props.errorMessage}
				showButtons={props.showButtons}
				token={props.token}
				setSignatureUploaded={props.setSignatureUploaded}
			/>
		</div>
	);
};

export default DigitalSignatureField;

interface Props {
	email?: string;
	workflowId?: string;
	consentSignature?: ConsentSignature;
	candidateId: string;
	customerId: number;
	onUpload?: (consent: ConsentSignature) => void;
	errorMessage?: string;
	showButtons?: boolean;
	token?: string;
	setSignatureUploaded?: (value: boolean) => void;
}

DigitalSignatureField.defaultProps = {
	showButtons: true,
	email: '',
	workflowId: '',
	consentSignature: null,
	onUpload: null,
	errorMessage: null,
	token: null,
	setSignatureUploaded: null
};
